import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-aa678bd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "completed-achievement-modal__image" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "completed-achievement-modal__title" }, "Congratulations!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "completed-achievement-modal__text" }, " You’ve received an achievement ", -1))
const _hoisted_5 = { class: "completed-achievement-modal__achievement-block" }
const _hoisted_6 = { class: "completed-achievement-modal__achievement-title" }
const _hoisted_7 = {
  key: 0,
  class: "completed-achievement-modal__achievement-level"
}

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/user';
import { getFirebaseStorageFileUrl } from '@/services/methods';

import BaseModal from '@/components/modals/BaseModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompletedAchievementModal',
  props: {
    isOpened: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const router = useRouter();
const userStore = useUserStore();

const image = computed(() => {
  if (!userStore.completedAchievement) {
    return;
  }
  return getFirebaseStorageFileUrl(userStore.completedAchievement.imgPath);
});

function seeAll() {
  router.push({ name: 'MyProfile', query: { tab: 'achievements' } });
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-opened": props.isOpened,
    "is-hide-close": "",
    "is-mobile-center": "",
    class: "completed-achievement-modal",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: image.value,
          alt: ""
        }, null, 8, _hoisted_2)
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(userStore).completedAchievement?.title), 1),
        (_unref(userStore).userDataCompletedAchievement?.currentLevel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(userStore).userDataCompletedAchievement?.currentLevel) + " level ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "completed-achievement-modal__see-all-button",
        onClick: seeAll
      }, " See all achievements ")
    ]),
    _: 1
  }, 8, ["is-opened"]))
}
}

})